export const getMatchupSlug = (game = {}, fullNames = false) => {
  const { teams = {} } = game;
  const { home = {}, away = {} } = teams;
  const { team: homeTeam = {} } = home;
  const { team: awayTeam = {} } = away;

  return fullNames
    ? `${awayTeam.name} @ ${homeTeam.name}`
    : `${awayTeam.abbreviation} @ ${homeTeam.abbreviation}`;
};

/**
 * Returns the display label for an incident. Uses gameDisplayLabel (non-game event name) when
 * present, otherwise getMatchupSlug for games, or gamePk as fallback.
 */
export const getIncidentDisplayLabel = incident => {
  if (incident.gameDisplayLabel) {
    return incident.gameDisplayLabel;
  }
  const game = incident.game;
  if (game?.teams) {
    const slug = getMatchupSlug(game);
    if (slug && !slug.includes("undefined")) {
      return slug;
    }
  }
  if (game?.name) {
    return game.name;
  }
  return incident.gamePk != null ? `Event ${incident.gamePk}` : "Unknown";
};
